module.exports = __webpack_public_path__ + "img/SKMJ_check1.84302d8d.png";